import React from 'react'

/**
 * Page-level horizontal frame. Two width preferences:
 *   - "prose"  → narrower, used for reading-oriented profile pages.
 *   - "wide"   → full app width, used for tables/listings.
 */
interface ContainerProps {
  width?: 'prose' | 'wide'
  className?: string
  children: React.ReactNode
}

const Container: React.FC<ContainerProps> = ({
  width = 'wide',
  className = '',
  children,
}) => {
  const max = width === 'prose' ? 'max-w-prose' : 'max-w-7xl'
  return (
    <div className={`${max} mx-auto px-4 sm:px-6 lg:px-8 ${className}`}>
      {children}
    </div>
  )
}

export default Container
